/* XSREZ accessibility fixes, 29 Oct 2026.

   Small, invisible repairs to markup that Horizon (or an app) renders, found by
   an axe-core WCAG 2.2 AA scan plus a manual keyboard pass. They live in this
   XSREZ file rather than in Horizon's own files so a theme update cannot wipe
   them. Nothing here changes how the site looks for mouse or touch shoppers.

   1. Image galleries that scroll sideways (product page and every product card)
      were not reachable by keyboard (Horizon sets tabindex="-1" on the scroller).
      Scrollers that actually overflow get tabindex="0" and a name.
   2. Gallery dots used aria-selected on plain buttons, which screen readers
      ignore. They are given the tab roles that make aria-selected valid.
   3. The product-page free-shipping progress bar had no accessible name.
   5. Product-recommendation loading placeholders put aria-label on plain divs
      (not allowed). They are hidden from assistive tech instead; the real
      products replace them a moment later.
   4. Quick-shop buttons on cards all read just "Choose" or "Add"; each now names
      its product. The quick-shop dialog had no name.

   Runs on load and again whenever the page re-renders sections (filters,
   infinite scroll, cart updates), throttled.
*/
(function () {
  function cardTitle(el) {
    var card = el.closest('product-card, .product-card, [class*="product-card"], .xs-card');
    if (!card) return '';
    var a = card.querySelector('a[aria-label]');
    if (a) return a.getAttribute('aria-label');
    var t = card.querySelector('.xs-card__title, [class*="title"]');
    return t ? t.textContent.trim() : '';
  }

  function fixScrollers() {
    document.querySelectorAll('slideshow-slides').forEach(function (el) {
      if (el.dataset.xsA11y) return;
      var dx = el.scrollWidth - el.clientWidth, dy = el.scrollHeight - el.clientHeight;
      if (dx <= 0 && dy <= 0) return;
      // Single-image cards round 1-2px wider than their frame, which makes
      // them technically scrollable with nothing to see. Clip that instead.
      if (dx <= 2 && dy <= 2) {
        if (dx > 0) el.style.overflowX = 'hidden';
        if (dy > 0) el.style.overflowY = 'hidden';
        return;
      }
      el.style.overflowX = '';
      el.style.overflowY = '';
      el.setAttribute('tabindex', '0');
      el.setAttribute('role', 'region');
      if (!el.getAttribute('aria-label')) {
        var t = cardTitle(el);
        el.setAttribute('aria-label', t ? t + ' images' : 'Product images');
      }
      el.dataset.xsA11y = '1';
    });
  }

  function fixDots() {
    document.querySelectorAll('.slideshow-controls__dots').forEach(function (list) {
      if (list.dataset.xsA11y) return;
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', 'Choose image');
      list.querySelectorAll(':scope > li').forEach(function (li) { li.setAttribute('role', 'presentation'); });
      list.querySelectorAll('button').forEach(function (b) { b.setAttribute('role', 'tab'); });
      list.dataset.xsA11y = '1';
    });
  }

  function fixProgress() {
    document.querySelectorAll('[role="progressbar"]:not([aria-label]):not([aria-labelledby])').forEach(function (p) {
      p.setAttribute('aria-label', 'Progress toward free shipping');
    });
  }

  function fixQuickAdd() {
    document.querySelectorAll('.quick-add__button').forEach(function (b) {
      if (b.dataset.xsA11y) return;
      var t = cardTitle(b);
      if (t) {
        var text = (b.textContent || '').trim().toLowerCase();
        b.setAttribute('aria-label', text.indexOf('add') === 0 ? 'Add ' + t + ' to cart' : 'Choose options for ' + t);
      }
      b.dataset.xsA11y = '1';
    });
    document.querySelectorAll('dialog.quick-add-modal:not([aria-label]):not([aria-labelledby])').forEach(function (d) {
      d.setAttribute('aria-label', 'Quick shop');
    });
  }

  function fixSkeletons() {
    document.querySelectorAll('div[aria-label]:not([role])[class*="skeleton"]').forEach(function (d) {
      d.removeAttribute('aria-label');
      d.setAttribute('aria-hidden', 'true');
    });
  }

  function run() {
    try { fixScrollers(); fixDots(); fixProgress(); fixQuickAdd(); fixSkeletons(); } catch (e) {}
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; run(); }, 250);
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', run);
    window.addEventListener('resize', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
